import { BUTTON_TYPES } from '@abiglobalhealth/go-types'

import { Button } from '@/components/Button'
import { getSlugTranslation } from '@/locale/utils'

interface ResponseActionsProps {
  canFollowUp: boolean
  onFollowUp: () => void
  onFinish: () => void
}

export const ResponseActions = ({ canFollowUp, onFollowUp, onFinish }: ResponseActionsProps) => (
  <section className="drop-shadow-chat-bubble flex w-full flex-col gap-6 rounded-2xl bg-white px-4 pt-4 pb-6">
    <p className="text-center font-bold">{getSlugTranslation('general.consultation.followUp.question')}</p>

    <div className="flex w-full flex-col gap-4">
      {canFollowUp && (
        <Button
          customClassName="rounded-full text-sm"
          data-testid="send-follow-up-message"
          hasShadow={false}
          onClick={onFollowUp}
          type={BUTTON_TYPES.OUTLINED}
        >
          {getSlugTranslation('general.consultation.followUp.confimButton')}
        </Button>
      )}

      <Button customClassName="rounded-full text-sm" data-testid="finish-and-get-report" hasShadow={false} onClick={onFinish}>
        {getSlugTranslation('general.consultation.followUp.getReportButton')}
      </Button>
    </div>
  </section>
)
